import { ProductPage } from "./ProductPage";
import { HoodieHistory } from "./HoodieHistory";
import { SizeChart, HOODIE_ROWS } from "./SizeChart";

const HOODIES = [
  {
    id: "regular",
    name: "The Regular",
    description:
      "The everyday hood. Brushed fleece with a relaxed fit and a kangaroo pocket — warm on the walk to the gym, easy to peel off once you're moving.",
    image: "/products/hoodie-black.jpg",
    hoverImage: "/products/hoodie-black-back.jpg",
    hoverHint: "Hover to see back",
    shop: {
      id: "hoodie-regular",
      name: "The Regular Hoodie",
      price: 55,
      colours: ["Black"],
    },
  },
  {
    id: "hyrox",
    name: "The Hyrox",
    description:
      "Still your everyday hoodie, with a Hyrox touch. The same relaxed fit and brushed fleece as The Regular.",
    image: "/products/hoodie-grey.jpg",
    hoverImage: "/products/hoodie-hyrox-back.jpg",
    hoverHint: "Hover to see back",
    shop: {
      id: "hoodie-hyrox",
      name: "The Hyrox Hoodie",
      price: 55,
      colours: ["Charcoal"],
    },
  },
];

export const Hoodie = () => (
  <ProductPage
    testId="hoodie"
    title="The Hoodie"
    intro="Two takes on the same everyday essential. The Regular keeps it clean; The Hyrox adds a Training Club touch."
    variants={HOODIES}
  >
    <SizeChart
      product="Hoodie"
      rows={HOODIE_ROWS}
      footnote="Tolerance ±1.5 cm on length, chest and shoulder · ±1 cm on sleeve"
    />
    <HoodieHistory />
  </ProductPage>
);
